'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n    font-size: ', 'px;\n    line-height: ', ';\n    text-align: left;\n\n    &,\n    code,\n    pre {\n      font-family: ', ';\n    }\n  '], ['\n    font-size: ', 'px;\n    line-height: ', ';\n    text-align: left;\n\n    &,\n    code,\n    pre {\n      font-family: ', ';\n    }\n  ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colorScheme = require('./color-scheme');

var _colorScheme2 = _interopRequireDefault(_colorScheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var codeFactory = function codeFactory(Highlight) {
  var defaultLineHeight = 1.4;

  // Override additional styles without
  // touching the theme object.
  var StyledHighlight = (0, _styledComponents2.default)(Highlight)(_templateObject, function (props) {
    return props.fontSize;
  }, defaultLineHeight, function (props) {
    return props.theme.monoFont;
  });

  var Code = function (_Component) {
    _inherits(Code, _Component);

    function Code() {
      _classCallCheck(this, Code);

      return _possibleConstructorReturn(this, (Code.__proto__ || Object.getPrototypeOf(Code)).apply(this, arguments));
    }

    _createClass(Code, [{
      key: 'getSyntaxTheme',
      value: function getSyntaxTheme() {
        var overridenTheme = this.props.theme.syntaxHighlight;

        // Allow to override syntax highlighting theme
        // using global styled-components theme settings.
        if (overridenTheme) {
          return overridenTheme;
        }

        return _colorScheme2.default;
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            className = _props.className,
            language = _props.language,
            theme = _props.theme;

        var code = this.props.children;

        // Use given font size or fall back to theme defaults
        var fontSize = this.props.fontSize || theme.slide.baseFontSize;

        return _react2.default.createElement(
          StyledHighlight,
          {
            style: this.getSyntaxTheme(),
            language: language,
            fontSize: fontSize,
            className: className
          },
          code
        );
      }
    }]);

    return Code;
  }(_react.Component);

  // Make sure the component has access to `theme` prop


  Code.propTypes = {
    language: _propTypes2.default.string,
    fontSize: _propTypes2.default.number,
    children: _propTypes2.default.string
  };
  Code.defaultProps = {
    // why not?
    language: 'javascript'
  };
  return (0, _styledComponents.withTheme)(Code);
};

exports.default = codeFactory;